import vars from "../helpers";

const init = () => {
	const $header = $('.header');
	const $headerNav = $header.find('.header__nav');

	$headerNav.find('li').each((index,listItem) => {
		const li = $(listItem);

	});

	$('.header__search-button').on('click', (e) => {
		$header.find('form').slideToggle();
		console.log('click')
	});

	if(vars.isMobile()) {
		setTimeout(() => {let link = $('.header__nav > li > a');
			link.each((index,item) => {

				$(item).html(`${$(item).text()}<div class="arrow for-mobile 123"><span></span><span></span></div>`);
			});}, 1000)
		$header.find('.header__nav li > a').on('click', (e) => {
			// $header.find('.header__nav li > a').removeClass('is-active');
			const $this = $(e.currentTarget);

			if(!$this.closest('.sub-menu')) {
				e.preventDefault();
			}

			$this.toggleClass('is-active');
			// $header.find('.header__nav li').find('.sub-menu').slideUp();
			$this.next('.sub-menu').slideToggle();
		});

		$('.footer').find('.is-nav').on('click', (e) => {
			// $header.find('.header__nav li > a').removeClass('is-active');
			const $this = $(e.currentTarget);

			$this.toggleClass('is-active');
			$this.next('.footer__list').slideToggle();
		});

		$header.find('.header__burger').on('click', (e) => {
			const $this = $(e.currentTarget);

			$this.addClass('is-active');
			$header.find('.is-menu').addClass('is-active');
			vars.$document.trigger('scrollStop');
		});

		$header.find('.close').on('click', (e) => {
			const $this = $(e.currentTarget);
			$header.find('.header__burger').removeClass('is-active');
			$this.removeClass('is-active');
			$header.find('.is-menu').removeClass('is-active');

			vars.$document.trigger('scrollInit');
		});
	}
};

export default {
	init,
}
